import { Key } from 'react'
import { Item, Section } from '@react-stately/collections'
import Styles from './WorkspacesMenu.module.scss'
import { groupWorkspacesByType } from 'utils/workspaceUtils'
import { AddSquare02, ArrowLeft, Logout1 } from 'blaze-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { Workspace } from 'types'
import { UserRole } from 'types'
import { WorkspaceMenuItemContent } from './WorkspaceMenuItemContent'
import { Text } from 'blaze-ui/Text/Text'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

export const WorkspacesMenu = ({
  onAction,
  workspaces,
  workspaceId,
  onBack,
}: {
  onAction: (key: Key) => void
  onBack?: () => void
  workspaces: Workspace[]
  workspaceId: number
  hideHeading?: boolean
}) => {
  const { member = [], guest: guestWorkspaces = [] } = groupWorkspacesByType(workspaces)
  const memberWorkspaces = member.filter((w) => w.role === UserRole.MEMBER)
  const ownerWorkspaces = member.filter((w) => [UserRole.ADMIN, UserRole.SUPER_ADMIN].includes(w.role))

  return (
    <div className={Styles.workspacesMenu}>
      {!!onBack && (
        <div className={Styles.backHeader}>
          <IconButton icon={ArrowLeft} size="xs" variant="tertiary" onPress={onBack} />
          <Text variant="secondary">Switch Workspace</Text>
        </div>
      )}
      <Menu
        aria-label="Workspaces"
        itemClassName={Styles.menuItem}
        onAction={onAction}
        selectionMode="single"
        selectedKeys={new Set([`workspace-${workspaceId}`])}
        showCheckmark
      >
        <Section title={<div className={Styles.workspacesHeader}>My Workspaces</div>}>
          {[
            ...ownerWorkspaces.map((w) => (
              <Item key={`workspace-${w.id}`} textValue={w.name}>
                <WorkspaceMenuItemContent workspace={w} isSelected={w.id === workspaceId} />
              </Item>
            )),
          ]}
        </Section>
        <Section title={<div className={Styles.workspacesHeader}>Workspaces I'm part of</div>}>
          {[
            ...memberWorkspaces.concat(guestWorkspaces).map((w) => (
              <Item key={`workspace-${w.id}`} textValue={w.name}>
                <WorkspaceMenuItemContent workspace={w} isSelected={w.id === workspaceId} />
              </Item>
            )),
          ]}
        </Section>
        <Section>
          {[
            <Item key="newWorkspace" textValue="Create new workspace">
              <div className={Styles.menuItemContent}>
                <AddSquare02 size={16} />
                <Text variant="secondary">Create workspace</Text>
              </div>
            </Item>,
            <Item key="signout" textValue="Sign out">
              <div className={Styles.menuItemContent}>
                <Logout1 size={16} /> <Text variant="secondary">Sign out</Text>
              </div>
            </Item>,
          ]}
        </Section>
      </Menu>
    </div>
  )
}
